import TempStarsTableTitle from "./TempStarsTableTitle.vue";
export default TempStarsTableTitle;
